import React from 'react';

const NotFound = () => <h2 className="text-center">Page not found</h2>;

export default NotFound;
